import { bindActionCreators } from 'redux';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { barberActiveShopId, getRoleIdType } from '../../auth/selectors';
import {
  addBarberUserService,
  deleteBarberService,
  getBarberUserServices,
  getBarberUserServicesV2,
  updateBarberUserService,
  updateBarberUserServiceOrder,
} from '../../main/services/actions';
import {
  addBarberTax,
  deleteBarberTax,
  fetchBarberTax,
  fetchBarberTaxes,
  updateBarberTax,
} from '../../main/settings/taxes/actions';
import {
  addBarberItem,
  deleteBarberItem,
  fetchBarberItem,
  fetchBarberItemsV2,
  updateBarberItem,
} from '../../products/products/actions';

const barberActionsWithShopIdRequired = [
  updateBarberUserServiceOrder,
  getBarberUserServices,
  getBarberUserServicesV2,
  addBarberUserService,
  updateBarberUserService,
  deleteBarberService,
  fetchBarberTaxes,
  fetchBarberTax,
  addBarberTax,
  updateBarberTax,
  deleteBarberTax,
  fetchBarberItem,
  fetchBarberItemsV2,
  addBarberItem,
  updateBarberItem,
  deleteBarberItem,
];

export const bindActionsForRoles = (dispatch, shopAction, barberAction, brandAction) => bindActionCreators({
  shop: shopAction,
  barber: barberAction,
  brand: brandAction,
}, dispatch);

export const withActionByRole = (action, shopAction, barberAction, brandAction) => compose(
  connect(
    state => ({
      roleIdType: getRoleIdType(state),
      barberActiveShopId: barberActiveShopId(state),
    }),
  ),
  connect(
    null,
    (dispatch, props) => {
      const barberActionRequiresShopId = barberActionsWithShopIdRequired.includes(barberAction);
      const barberActionWithPassedShop = (...args) => barberAction(props.barberActiveShopId, ...args);

      return {
        [action]: bindActionsForRoles(
          dispatch,
          shopAction,
          barberActionRequiresShopId ? barberActionWithPassedShop : barberAction,
          brandAction
        ),
      };
    }
  ),
  withHandlers({
    [action]: props => (...args) => {
      const fn = props[action][props.roleIdType.type];
      if (fn) {
        return fn(props.roleIdType.id, ...args);
      }
    },
  }),
);

export const emptyAction = () => ({ type: '', error: null });
